import { render, staticRenderFns } from "./serveEight.vue?vue&type=template&id=4286ca04&scoped=true&"
import script from "./serveEight.vue?vue&type=script&lang=js&"
export * from "./serveEight.vue?vue&type=script&lang=js&"
import style0 from "./serveEight.vue?vue&type=style&index=0&id=4286ca04&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4286ca04",
  null
  
)

export default component.exports